import type { PropsWithChildren } from 'react'

import CheckOrders from '../components/business/CheckOrders'
import ActiveOrdersProvider from './activeOrders'
import { MenuProvider } from './menu'
import { SellerProvider } from './seller'
import OrdersWebSocketProvider from './ordersWebSocket'
import { UserActivityProvider } from './userActivity'

const AppProvider = ({ children }: PropsWithChildren) => {
  return (
    <SellerProvider>
      <OrdersWebSocketProvider>
        <ActiveOrdersProvider>
          <UserActivityProvider>
            <MenuProvider>
              <CheckOrders />
              {children}
            </MenuProvider>
          </UserActivityProvider>
        </ActiveOrdersProvider>
      </OrdersWebSocketProvider>
    </SellerProvider>
  )
}

export default AppProvider
